import script from "./GoogleLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleLoginButton.vue?vue&type=style&index=0&id=4c4db0b3&lang=css"

const __exports__ = script;

export default __exports__